export var COOPER_SOURCE = {
  FANGHUI: 'fanghui'
};
export var DoType;

(function (DoType) {
  DoType[DoType["none"] = 0] = "none";
  DoType[DoType["onlySave"] = 1] = "onlySave";
  DoType[DoType["saveAndUse"] = 2] = "saveAndUse"; // 保存并使用
})(DoType || (DoType = {}));

export var InvoiceTitleType;

(function (InvoiceTitleType) {
  InvoiceTitleType[InvoiceTitleType["company"] = 1] = "company";
  InvoiceTitleType[InvoiceTitleType["person"] = 2] = "person";
  InvoiceTitleType[InvoiceTitleType["noEnterpriseCompany"] = 3] = "noEnterpriseCompany"; // 非企业单位
})(InvoiceTitleType || (InvoiceTitleType = {})); // 当前环境


export var EnvSecurityType;

(function (EnvSecurityType) {
  EnvSecurityType[EnvSecurityType["weChat"] = 1] = "weChat";
  EnvSecurityType[EnvSecurityType["app"] = 2] = "app";
  EnvSecurityType[EnvSecurityType["web"] = 3] = "web"; // 纯web
})(EnvSecurityType || (EnvSecurityType = {}));

export var InvoiceSpecialType;

(function (InvoiceSpecialType) {
  InvoiceSpecialType[InvoiceSpecialType["common"] = 1] = "common";
  InvoiceSpecialType[InvoiceSpecialType["special"] = 2] = "special";
  InvoiceSpecialType[InvoiceSpecialType["commonWithFourItem"] = 3] = "commonWithFourItem"; // 普票：表单展示六项数据，只有抬头和税号是必填项，其他四项选填。
})(InvoiceSpecialType || (InvoiceSpecialType = {}));

export var validTypes;

(function (validTypes) {
  validTypes[validTypes["notPass"] = 0] = "notPass";
  validTypes[validTypes["validPass"] = 1] = "validPass";
  validTypes[validTypes["noValue"] = 2] = "noValue"; // 无输入值
})(validTypes || (validTypes = {})); // 邮箱地址


export var emailAddressReg = /\S+@\S+/; // 税盘编号

export var taxDiskNumber = /^(33|44)\d{12}$/; // 姓名

export var connectName = /[(\u4E00-\u9FA5|\*)]{2,5}/; // 手机号码

export var phoneNumberReg = /^1[1-9]\d{9}$/; // 脱敏手机号

export var phoneNumberRegNeedStar = /^1[1-9](\d|\*){9}$/; // 抬头名称

export var titleReg = /^[\u4E00-\u9FA5A-Za-z0-9<>〈〉《》\[\]【】（）\(\)﹙﹚〔〕“”━\—\―\-_〇○\*\: ;,·•\.。\&\?`、Ⅰ\Ⅱ\+\/#@]{0,60}$/; // 税号
// export const taxNumberReg = /^([A-Za-z0-9]{15}|[A-Za-z0-9]{17,18}|[A-Za-z0-9]{20})$/

export var taxNumberReg = /^[A-Za-z0-9]{15,20}$/; // 脱敏税号

export var taxNumberRegWithStar = /^([A-Za-z0-9\*]{15}|[A-Za-z0-9\*]{17,18}|[A-Za-z0-9\*]{20})$/; // export const taxNumberReg = /^[A-Z0-9]{18}$/;
// 公司地址

export var addressReg = /^[\u4E00-\u9FA5A-Za-z0-9_\-\－（）()）、《》\[\]【】\_*,·.~#@，：:]{1,60}$/; // 银行名称
// export const bankNameReg = /^[\u4E00-\u9FA5A-Za-z0-9_\-\－（）()）、#@]{4,30}$/

export var bankNameReg = /^[\u4E00-\u9FA5A-Za-z0-9_\-\－（）()）、#@]{1,30}$/; // 公司电话
// export const cellPhoneReg = /^\d{1,3}[\d-]{3,13}$/

export var cellPhoneReg = /^\d[\d-]*$/; // 银行卡号
// export const bankCardReg = /^(\d{9,25})$/

export var bankCardReg = /^(\d{1,26})$/;
export var titleErrorMsg = '请填写正确的抬头名称';
export var taxErrorMsg = '请填写正确的公司税号';
export var taxDiskErrorMsg = '仅支持12位数字';
export var phoneErrorMsg = '请填写正确的手机号码';
export var nameErrorMsg = '仅支持中文';
export var backupErrorMsg = '仅支持2-50个字符';
export var regObj = {
  emailAddressReg: emailAddressReg,
  taxDiskNumber: taxDiskNumber,
  connectName: connectName,
  phoneNumberReg: phoneNumberReg,
  phoneNumberRegNeedStar: phoneNumberRegNeedStar,
  titleReg: titleReg,
  taxNumberReg: taxNumberReg,
  taxNumberRegWithStar: taxNumberRegWithStar,
  addressReg: addressReg,
  bankNameReg: bankNameReg,
  cellPhoneReg: cellPhoneReg,
  bankCardReg: bankCardReg
};
export var errMsgObj = {
  titleErrorMsg: titleErrorMsg,
  taxErrorMsg: taxErrorMsg,
  taxDiskErrorMsg: taxDiskErrorMsg,
  phoneErrorMsg: phoneErrorMsg,
  nameErrorMsg: nameErrorMsg,
  backupErrorMsg: backupErrorMsg
};
export var InvoiceTipModalContent = '国家税务总局规定：2017年7月1日起，开具增值税普通发票，需提供单位抬头与税号，否则无法用于单位报销；开具增值税专用发票，需提供单位完整信息。请咨询单位财务部门获取相关信息。'; // 归集状态

export var COLLECTION_STATUS = {
  TODO: 1,
  SUCCESS: 2,
  REDFLUSH: 3,
  UNHANDLED: 4,
  REVOKED: 5,
  FAILED: 6 // 开票失败

};
export var INVOICE_FILE_TYPE = {
  UNKNOW: 0,
  PDF: 1,
  OFD: 2
};
export var STATUS_MAPPING = {
  1: '待开票',
  2: '已开票',
  3: '已红冲',
  4: '待开具',
  5: '已作废',
  6: '开票失败'
}; // 开票是产生多个发票情景下的开票状态。

export var STATUS_MAPPING_BATCH_INVOICE = {
  1: '开票中',
  2: '已开票',
  3: '已红冲',
  4: '待开票',
  5: '已作废',
  6: '开票失败'
}; // 电子开票状态

export var E_INVOICE_STATUS = {
  TODO: 1,
  SUCCESS: 2,
  CANCELED: 3,
  // REVERSE: 4,	// 已红冲
  UNHANDLED: 4,
  FAILED: 5 // 已失败

};
export var UseSuggestMethod;

(function (UseSuggestMethod) {
  UseSuggestMethod[UseSuggestMethod["useHands"] = 1] = "useHands";
  UseSuggestMethod[UseSuggestMethod["clickTitle"] = 2] = "clickTitle";
  UseSuggestMethod[UseSuggestMethod["useHistory"] = 3] = "useHistory";
  UseSuggestMethod[UseSuggestMethod["useWeChatTitle"] = 4] = "useWeChatTitle";
  UseSuggestMethod[UseSuggestMethod["useClipboardTitle"] = 5] = "useClipboardTitle"; // 使用剪贴板的复制信息
})(UseSuggestMethod || (UseSuggestMethod = {}));